import React from 'react';
import { useSWRConfig } from 'swr';
import {
  SurveyGetItemQuery,
  SurveyGetItemResponse,
  SurveyGetListQuery,
} from './reader';

// Cache Key Generator
export const surveyCacheKeyGenerator = {
  generateListKey: ({
    query,
    ignore = false,
  }: {
    query?: SurveyGetListQuery;
    ignore?: boolean;
  }) => {
    if (ignore) {
      return;
    }

    return ['SURVEY', 'LIST', [query]] as const;
  },
  generateItemKey: ({
    query,
    ignore = false,
  }: {
    query?: SurveyGetItemQuery;
    ignore?: boolean;
  }) => {
    if (ignore) {
      return;
    }

    return ['SURVEY', 'ITEM', query] as const;
  },
};

// Cache Mutator
export const useSurveyCacheMutator = () => {
  const { mutate } = useSWRConfig();

  return React.useMemo(
    () => ({
      mutateList: (query: SurveyGetListQuery) =>
        mutate(surveyCacheKeyGenerator.generateListKey({ query })),
      mutateItem: (
        query: SurveyGetItemQuery,
        newData?: SurveyGetItemResponse,
        revalidate?: boolean
      ) =>
        mutate(
          surveyCacheKeyGenerator.generateItemKey({ query }),
          newData,
          revalidate
        ),
    }),
    [mutate]
  );
};
